import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter } from 'react-router'
import './index.css'
import { AppProviders, createAppQueryClient } from './app/AppProviders'
import { appRoutes } from './app/router'

const root = document.getElementById('root')
if (root) {
  const router = createBrowserRouter(appRoutes)
  const queryClient = createAppQueryClient()
  createRoot(root).render(
    <StrictMode>
      <AppProviders router={router} queryClient={queryClient} />
    </StrictMode>,
  )
}
